module.exports = __webpack_public_path__ + "static/img/xinfeng-nei-active.6df6ecb0.png";